"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var select_field_1 = require("../../../../../../../components/form/select-field");
var react_2 = require("react");
var objective_node_1 = __importDefault(require("../objective_node"));
var challenge_1 = require("../../../../../../../reducers/slices/challenge/challenge");
var react_redux_1 = require("react-redux");
var challengeEditorContext_1 = require("../../../../../../../contexts/challengeEditorContext");
var SubscriptionObjectiveNode = function (props) {
    var _a, _b;
    var isReadOnly = (0, challengeEditorContext_1.useChallengeReadOnly)();
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _c = (0, react_2.useState)("1"), quantity = _c[0], setQuantity = _c[1];
    (0, react_2.useEffect)(function () {
        var _a, _b, _c, _d;
        setQuantity((_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.trigger) === null || _b === void 0 ? void 0 : _b.trigger_quantity) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "1");
    }, [(_b = (_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.trigger) === null || _b === void 0 ? void 0 : _b.trigger_quantity]);
    var setConfigData = function (config) {
        dispatch((0, challenge_1.setNode)(__assign(__assign({}, props), { data: __assign(__assign({}, data), { config: config }) })));
    };
    var updateScopes = function (scopeType, selectedValues) {
        var _a;
        var currentScopes = ((_a = data.config) === null || _a === void 0 ? void 0 : _a.scopes) || [];
        // Remove existing scopes of this type
        var filteredScopes = currentScopes.filter(function (scope) { return scope.type !== scopeType; });
        // Add new scopes for each selected value
        var newScopeObjects = selectedValues.map(function (value) { return ({
            type: scopeType,
            value: value
        }); });
        var newScopes = __spreadArray(__spreadArray([], filteredScopes, true), newScopeObjects, true);
        setConfigData(__assign(__assign({}, data.config), { scopes: newScopes }));
    };
    var getScopeValues = function (scopeType) {
        var _a;
        var scopes = ((_a = data.config) === null || _a === void 0 ? void 0 : _a.scopes) || [];
        return scopes
            .filter(function (s) { return s.type === scopeType; })
            .map(function (s) { return s.value; });
    };
    var configurationComponent = function () {
        var _a;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsxs)(react_1.TextField, { isReadOnly: isReadOnly, value: (_a = data.config) === null || _a === void 0 ? void 0 : _a.title, onChange: function (value) {
                        setConfigData(__assign(__assign({}, data.config), { title: value }));
                    }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Title" }), (0, jsx_runtime_1.jsx)(react_1.Input, { maxLength: 120 })] }), (0, jsx_runtime_1.jsxs)(react_1.TextField, { isReadOnly: isReadOnly, value: quantity, onChange: function (value) {
                        setQuantity(value);
                        setConfigData(__assign(__assign({}, data.config), { trigger: { trigger_quantity: parseInt(value) || 1 } }));
                    }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Trigger Quantity" }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "number", min: 1, max: 999999 })] }), (0, jsx_runtime_1.jsx)(select_field_1.SelectField, { isDisabled: isReadOnly, label: "Payment Method", selectionMode: "multiple", placeholder: "Any payment method", value: getScopeValues("payment_method"), onChange: function (value) { return updateScopes("payment_method", value); }, items: [{ label: "Credit/Debit Card", value: "CARD" }, { label: "Wallet", value: "WALLET" }] })] }));
    };
    return (0, jsx_runtime_1.jsx)(objective_node_1.default, __assign({ data: data }, props, { configurationComponent: configurationComponent }));
};
exports.default = (0, react_2.memo)(SubscriptionObjectiveNode);
